import { render, staticRenderFns } from "./kv-scrollbar.vue?vue&type=template&id=38cc8b87"
import script from "./kv-scrollbar.vue?vue&type=script&lang=js"
export * from "./kv-scrollbar.vue?vue&type=script&lang=js"
import style0 from "./kv-scrollbar.vue?vue&type=style&index=0&id=38cc8b87&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports